import { render } from "./UserLogin.vue?vue&type=template&id=95ca763a&ts=true"
import script from "./UserLogin.vue?vue&type=script&lang=ts"
export * from "./UserLogin.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__